var exports = {
  "kL": "xe533113f--f20625--container",
  "zg": "xe533113f--f20625--item_info",
  "VA": "xe533113f--f20625--subtitle",
};

module.exports = exports;
